import axios from "axios";
import {ELASTIC_SEARCH_CAMPAIGNS_INDEX} from "../../firebase";

export const getRecommendations = async ({categories, tags, backers, userId}) => {

    const boolParams = {
        must_not: [
            {
                exists: {
                    field: 'hidden'
                },
            },
            {
                term : { 
                    state: "ended",
                },
            },
            {
                term : { 
                    author_id: userId
                },
            },
            
        ],
        must: [
            {
                terms: {
                    'category.keyword': categories
                },
            }
        ],
        should: [
            {
                "script": {
                    "script": {
                        "inline": `Float.parseFloat(doc['backers'].value) >= ${backers[0]} && Float.parseFloat(doc['backers'].value) <= ${backers[1]}`,
                        "lang": "painless"
                    }
                }
            },
        ]
    }


    if(tags.length) {
        boolParams.should.push({
            terms: {
                tags: tags
            }
        })
    }

    const body = {
        query: {
            function_score: {
                query: {
                    bool: {
                        filter: {
                            bool: boolParams
                        }
                    },
                },
                boost_mode: "replace",
                functions: [
                    {
                        random_score:  {
                            seed: parseInt(Math.random() * 100)
                        }
                    }
                ],
            },
        },
        size: 30
    }

    return axios
        .post(`https://search.crossprom.com/${ELASTIC_SEARCH_CAMPAIGNS_INDEX}/_search`, body)
}
